import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AsistenciaCursoComponent} from '../asistencia/asistencia-curso/asistencia-curso.component';
import {TiposAsistenciaResolver} from './_resolvers/tipos-asistencia-resolver.service';
import {AsistenciaReporteDirectorCursoComponent} from './reporte-director-curso/reporte-director-curso.component';
import {AsistenciaReporteDireccionAcademicaComponent} from './reporte-direccion-academica/reporte-direccion-academica.component';
import {AsistenciaReporteCursoComponent} from './reporte-curso/reporte-curso.component';
import {AsistenciaReporteAlertasComponent} from './reporte-alertas/reporte-alertas.component';
import {EstudioResumenResolver} from '../estudio/resumen/estudio-resumen-resolver.service';
import {AuthGuard} from '../../_guards';
import {ReporteVigilanciaTareasComponent} from './reporte-vigilancia-tareas/reporte-vigilancia-tareas.component';
import {ReporteTransporteComponent} from './reporte-transporte/reporte-transporte.component';
import { ReporteDireccionCursoComponent } from './reporte-direccion-curso/reporte-direccion-curso.component';
import { AsistenciaReporteGeneralComponent } from './reporte-general/reporte-general.component';
import { AsistenciaComponent } from './asistencia.component';

const nivelacionesRoutes: Routes = [
    {
      path: 'asistencia',
      component: AsistenciaComponent,
      canActivate: [AuthGuard],
      resolve: {
        tiposAsistencia: TiposAsistenciaResolver,
        periodos: EstudioResumenResolver
      },
      children: [
        {
          path: 'general/fecha/:fecha',
          component: AsistenciaReporteGeneralComponent
        },
        {
          path: 'general',
          component: AsistenciaReporteGeneralComponent
        },
        {
          path: 'reporte',
          resolve: {
            tiposAsistencia: TiposAsistenciaResolver,
            periodos: EstudioResumenResolver
          },
          children: [
            {
              path: 'curso/:cursoID/periodo/:periodoID',
              component: AsistenciaReporteDirectorCursoComponent
            },
            {
              path: 'curso/:cursoID',
              component: AsistenciaReporteDirectorCursoComponent
            },
            {
              path: 'direccion-academica/periodo/:periodoID',
              component: AsistenciaReporteDireccionAcademicaComponent
            },
            {
              path: 'direccion-academica',
              component: AsistenciaReporteDireccionAcademicaComponent
            },
            {
              path: 'cursos/periodo/:periodoID',
              component: AsistenciaReporteCursoComponent
            },
            {
              path: 'cursos',
              component: AsistenciaReporteCursoComponent
            },
            {
              path: 'alumnos/alertas/periodo/:periodoID',
              component: AsistenciaReporteAlertasComponent
            },
            {
              path: 'alumnos/alertas',
              component: AsistenciaReporteAlertasComponent
            },
            {
              path: 'vigilancia-tareas/fecha/:fecha',
              component: ReporteVigilanciaTareasComponent
            },
            {
              path: 'vigilancia-tareas',
              component: ReporteVigilanciaTareasComponent
            },
            {
              path: 'transporte/fecha/:fecha',
              component: ReporteTransporteComponent
            },
            {
              path: 'transporte',
              component: ReporteTransporteComponent
            },
            {
              path: 'materias',
              component: ReporteDireccionCursoComponent
            }
          ]
        },
        {
          path: 'materia',
          resolve: {
            tiposAsistencia: TiposAsistenciaResolver
          },
          children: [
            {
              path: ':mcpID/fecha/:fecha',
              component: AsistenciaCursoComponent
            },
            {
              path: ':mcpID',
              component: AsistenciaCursoComponent
            }
          ]
        }

      ]
    },
  ]
;

@NgModule({
  imports: [
    RouterModule.forChild(nivelacionesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AsistenciaRoutingModule {
}
